/* tslint:disable */
import {
  UserProfile,
  CompanyAccount,
  PropertySettlement
} from '../index';

declare var Object: any;
export interface LandlordDetailsInterface {
  "start_date": Date;
  "end_date"?: Date;
  "dob"?: Date;
  "account_status"?: string;
  "commission_percentage"?: number;
  "payment_method"?: string;
  "bank_name"?: string;
  "bank_branch"?: string;
  "bank_account_number"?: string;
  "bank_swift_code"?: string;
  "mpesa_number"?: string;
  "tax_pin"?: string;
  "contract_type"?: string;
  "notes"?: string;
  "notification_preferences"?: any;
  "documents"?: any;
  "is_verified"?: boolean;
  "verification_date"?: Date;
  "last_payment_date"?: Date;
  "next_payment_date"?: Date;
  "id"?: number;
  "land_lord_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  land_lord?: UserProfile;
  properties?: CompanyAccount[];
  settlements?: PropertySettlement[];
}

export class LandlordDetails implements LandlordDetailsInterface {
  "start_date": Date;
  "end_date": Date;
  "dob": Date;
  "account_status": string;
  "commission_percentage": number;
  "payment_method": string;
  "bank_name": string;
  "bank_branch": string;
  "bank_account_number": string;
  "bank_swift_code": string;
  "mpesa_number": string;
  "tax_pin": string;
  "contract_type": string;
  "notes": string;
  "notification_preferences": any;
  "documents": any;
  "is_verified": boolean;
  "verification_date": Date;
  "last_payment_date": Date;
  "next_payment_date": Date;
  "id": number;
  "land_lord_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  land_lord: UserProfile;
  properties: CompanyAccount[];
  settlements: PropertySettlement[];
  constructor(data?: LandlordDetailsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LandlordDetails`.
   */
  public static getModelName() {
    return "LandlordDetails";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LandlordDetails for dynamic purposes.
  **/
  public static factory(data: LandlordDetailsInterface): LandlordDetails{
    return new LandlordDetails(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LandlordDetails',
      plural: 'LandlordDetails',
      path: 'LandlordDetails',
      idName: 'id',
      properties: {
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "dob": {
          name: 'dob',
          type: 'Date'
        },
        "account_status": {
          name: 'account_status',
          type: 'string',
          default: 'ACTIVE'
        },
        "commission_percentage": {
          name: 'commission_percentage',
          type: 'number',
          default: 0
        },
        "payment_method": {
          name: 'payment_method',
          type: 'string'
        },
        "bank_name": {
          name: 'bank_name',
          type: 'string'
        },
        "bank_branch": {
          name: 'bank_branch',
          type: 'string'
        },
        "bank_account_number": {
          name: 'bank_account_number',
          type: 'string'
        },
        "bank_swift_code": {
          name: 'bank_swift_code',
          type: 'string'
        },
        "mpesa_number": {
          name: 'mpesa_number',
          type: 'string'
        },
        "tax_pin": {
          name: 'tax_pin',
          type: 'string'
        },
        "contract_type": {
          name: 'contract_type',
          type: 'string'
        },
        "notes": {
          name: 'notes',
          type: 'string'
        },
        "notification_preferences": {
          name: 'notification_preferences',
          type: 'any',
          default: <any>null
        },
        "documents": {
          name: 'documents',
          type: 'any',
          default: <any>null
        },
        "is_verified": {
          name: 'is_verified',
          type: 'boolean',
          default: false
        },
        "verification_date": {
          name: 'verification_date',
          type: 'Date'
        },
        "last_payment_date": {
          name: 'last_payment_date',
          type: 'Date'
        },
        "next_payment_date": {
          name: 'next_payment_date',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "land_lord_id": {
          name: 'land_lord_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        land_lord: {
          name: 'land_lord',
          type: 'UserProfile',
          model: 'UserProfile',
          relationType: 'belongsTo',
                  keyFrom: 'land_lord_id',
          keyTo: 'id'
        },
        properties: {
          name: 'properties',
          type: 'CompanyAccount[]',
          model: 'CompanyAccount',
          relationType: 'hasMany',
          modelThrough: 'PropertyOwner',
          keyThrough: 'property_id',
          keyFrom: 'id',
          keyTo: 'property_owner_id'
        },
        settlements: {
          name: 'settlements',
          type: 'PropertySettlement[]',
          model: 'PropertySettlement',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'landlord_id'
        },
      }
    }
  }
}
